import { Loader2 } from 'lucide-react';

const block = 'rounded bg-muted animate-pulse motion-reduce:animate-none';

export const ConversationsSkeleton = () => (
  <div className="flex h-[calc(100vh-4rem)]">
    <div className="w-1/3 min-w-[280px] border-r border-border bg-card">
      <div className="space-y-3 border-b border-border p-3">
        <div className={`h-5 w-32 ${block}`} />
        <div className={`h-8 w-full ${block}`} />
        <div className="flex gap-2">
          <div className={`h-8 flex-1 ${block}`} />
          <div className={`h-8 flex-1 ${block}`} />
        </div>
      </div>
      <div className="space-y-3 p-3">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="flex gap-2.5">
            <div className={`h-9 w-9 shrink-0 rounded-full ${block}`} />
            <div className="flex-1 space-y-1.5">
              <div className={`h-3.5 w-3/4 ${block}`} />
              <div className={`h-3 w-full ${block}`} />
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className="flex flex-1 items-center justify-center bg-muted/40">
      <Loader2 className="h-7 w-7 animate-spin text-muted-foreground motion-reduce:animate-none" />
    </div>
  </div>
);
